/** Created by azhou on 2019/3/20.*/
<template>
    <div>
      <public-title>供应商团款[提现申请]</public-title>
      <div class="bg-white load-area">
        <search-con class="mop-none" :orderType="orderType" @getSearchCon="getSearchCon"/>
        <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
        <div v-else>
          <!--酒店-->
            <ul class="list-head mt-3">
              <li  v-for="item in titleArrHotelList" :key="item" :class="item=='开户银行'||item=='所属供应商'? 'w-70' : item=='操作'?'w-30':'w-50'" v-html="item"></li>
            </ul>
            <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
            <li class="w-50 list-item-col flex-column breakword goHotelDetail" @click="goHotelDetail(item)">{{item.oid}}</li>
            <li class="w-70 list-item-col">{{item.hotel_title}}</li>
            <li class="w-50 list-item-col">{{item.truename}}</li>
            <li class="w-70 bank_name">
              <div>开户银行：{{item.bank_name||'无'}}</div>
              <div>支行名称：{{item.branch||'无'}}</div>
              <div>银行卡号：{{item.bank_card||'无'}}</div>
            </li>
            <!-- <li class="w-50 list-item-col">{{item.branch}}</li>
            <li class="w-80 list-item-col">{{item.bank_card}}</li> -->
            <li class="w-50 list-item-col">{{item.price | formatMoney}}</li>
            <li class="w-50 list-item-col">{{item.price_pay/100 | formatMoney}}</li>
            <li class="w-50 list-item-col red">{{item.price_pay/100>=item.price?item.price:item.price_pay | formatMoney}}</li>
            <li class="w-50 list-item-col red">未处理</li>
            <li class="w-30 list-item-col-end flex-wrap">
                <el-button  size="mini"  type="success" @click="financeprice(item)">提交财务</el-button>
              </li>
            </ul>
          <el-pagination background layout="prev, pager, next" class="mt-4"
                         :total="AdminDataLists.total" :current-page="Number(Formdata.page)"
                         @current-change="v => {this.Formdata.page=v;getDataLists()}"/>
            
        </div>
      </div>
      <el-dialog title="提交财务" :visible.sync="finance" width="340px" class="paymentist" :close-on-click-modal="false" top="16%">
            <commission v-if="finance" :remark="remark" @finance="finance=!finance" :modify="modify" :oid="pay_id" :price_pay="price_pay" @submitFinance="submitFinance"></commission>
      </el-dialog>
    </div>
</template>

<script>
  import commission from './Subassembly/commission.vue'
    import SearchCon from './Subassembly/SearchCon.vue'
  import { mapGetters, mapActions,mapState } from 'vuex'
  export default {
    name: 'WithdrawHotel',
    components:{commission,SearchCon},
    computed: {
      ...mapState(['AdminDataLists','userLoginMessage']),
      ...mapGetters(['storeInfo','isAdmin']),
      queryCon() { return this.$route.query },
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
      timeChoose() {
        let arr =  [
          {name:`按时间段`,value:'timeFrame'},
          {name:`按日期`,value:'timeArr'},
        ];
        return arr
      },
    },
    watch:{
    },
    created() { this.getDataLists();},
    data() {
      return {
        pay_id:'',                        //提交id
        cardItem:{},                      //选择订单
        finance:false,                    //提交财务弹窗
        titleArrHotelList:['订单号','所属供应商','企业名称/个人姓名','开户银行','订单金额(元)','实际支付(元)','最多可提(元)','状态','操作'],
        orderType:3,
        Formdata:{
          page:1,
        },
        
      }
    },
    methods:{
      ...mapActions(['getAdminDataLists','adminSubmitFinance',]),
      /*根据条件搜索订单*/
      getSearchCon(con) {
        this.Formdata = con;
        this.getDataLists(con);
      },
      //获取酒店打款列表
      getDataLists(con) {
        let data = {
          ...this.queryCon,
          ...this.Formdata,
        }
        if (con) data.page = 1
        this.getAdminDataLists({
          type:'withdrawalHotelList',
          data
        });
      },
      /**
       * 管理员提交财务
       */
      submitFinance(ruleForm){
        this.finance=!this.finance
        this.adminSubmitFinance({
          type:3,
          data:ruleForm,
          successFun: () => {
            this.getDataLists();
              this._alert('已提交财务，可在待打款列表中查看');
          }
        });
      },
      /**
       * 手续费最大值
      */
        financeprice(res){
          this.finance=true;
          if(res.price_pay/100>res.price){
            this.price_pay=res.price;
          }else{
            this.price_pay=res.price_pay/100;
          }
          this.modify=res.charge/100;
          this.pay_id = res.oid;
          this.remark=res.remark;
        },
      //订单详情页
      goHotelDetail (e) {
            let cardItem=e;
            console.log(this.storeInfo)
            let routeUrl = this.$router.resolve({
                name: 'OrderDetail',
                query: {
                    orderType: 3,
                    orderId: cardItem.oid,
                    storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
                    status: cardItem.status,
                }
            });
            window.open(routeUrl.href, '_blank');
      },
    }
  }
</script>

<style lang="scss" scoped>
  .el-select{
    float: left;
    margin-right: 30px
  }
  .textal{
    width: 56px!important;
    display: inline-block;
    text-align-last: justify;
  }
  .mr-auto{
    span{
      display: inline-block;
      width: 150px;
      text-align: right;
      vertical-align: text-bottom
    }
    .vt{
      vertical-align: top
    }
  }
  .vm{
    margin-left: 2px;
    vertical-align: middle;
    cursor: pointer;
  }
  .goHotelDetail{
    cursor: pointer;

  }
 .goHotelDetail:hover{
    color: var(--smtc-color-primary);
  }
  .bank_name{
    text-align: left;
    border-right: 1px #eee solid;
    padding: 10px;
  }
</style>
